import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { useLang } from "../context/LanguageContext";

export function Layout({ children }) {
  const loc = useLocation();
  const { t } = useLang();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  useEffect(() => {
    if (loc.hash) {
      const id = loc.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 250);
    } else {
      window.scrollTo(0, 0);
    }
  }, [loc.pathname, loc.hash]);

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--lo-bg)" }}>
      <div className="fixed top-0 left-0 right-0 z-50 h-[34px] flex items-center justify-center overflow-hidden border-b" style={{ background: "var(--lo-announce-bg)", borderColor: "var(--lo-border-rose)" }} data-testid="announcement-bar">
        <p className="overline text-center px-4" style={{ fontSize: "0.6rem", color: "var(--lo-rose-hi)" }}>
          {t("announce")}
        </p>
      </div>
      <Header />
      <main className="flex-1 pt-[34px]">{children}</main>
      <Footer />
    </div>
  );
}
